<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <app-breadcrumb
                [title]="'Gestion de Portefeuille'"
                [active_item]="'Achat de Produits & Services'"
            ></app-breadcrumb>
            <div class="card">
                <div class="card-body">
                    <div [hidden]="!initialView">
                        <div class="statistique-block">
                            <div>
                                <app-card-stock
                                    [cardBgColor]="'#FFFFFF'"
                                    [ngClass]="['ligne-card']"
                                    [cardBorderColor]="'#DF7401'"
                                    [legend]="'Crédit disponible (FCFA)'"
                                    [count]="creditDisponible || '0'"
                                    [legendColor]="'#DF7401'"
                                    [countColor]="'#000000'"
                                ></app-card-stock>
                            </div>
                            <div>
                                <app-card-stock
                                    [cardBgColor]="'#FFFFFF'"
                                    [ngClass]="['ligne-card']"
                                    [cardBorderColor]="'#DF7401'"
                                    [legend]="'Solde Global Data (Go)'"
                                    [count]="soldeData || '0'"
                                    [legendColor]="'#DF7401'"
                                    [countColor]="'#000000'"
                                ></app-card-stock>
                            </div>
                            <div>
                                <app-card-stock
                                    [cardBgColor]="'#FFFFFF'"
                                    [cardBorderColor]="'#DF7401'"
                                    [legend]="'Nombre SIM MSISDN'"
                                    [count]="soldeSimA || '0'"
                                    [legendColor]="'#DF7401'"
                                    [countColor]="'#000000'"
                                ></app-card-stock>
                            </div>
                            <div>
                                <app-card-stock
                                    [cardBgColor]="'#FFFFFF'"
                                    [cardBorderColor]="'#DF7401'"
                                    [legend]="'Nombre SIM Blanches'"
                                    [count]="soldeSimB || '0'"
                                    [legendColor]="'#DF7401'"
                                    [countColor]="'#000000'"
                                ></app-card-stock>
                            </div>
                        </div>
                        <hr style="margin-top: -0.4rem" />
                        <div class="row filter_wrapper">
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label>
                                        <b>N° Ligne</b>
                                    </label>
                                    <input
                                        placeholder="N° Ligne"
                                        [(ngModel)]="selectedTranaction"
                                        type="text"
                                        pInputText
                                    />
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label>
                                        <b>Reference</b>
                                    </label>
                                    <input
                                        placeholder="Réference"
                                        [(ngModel)]="selectedReference"
                                        type="text"
                                        pInputText
                                    />
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label>
                                        <b>Statut</b>
                                    </label>
                                    <p-dropdown
                                        [options]="listStatuts"
                                        [(ngModel)]="selectedStatut"
                                        [showClear]="true"
                                        placeholder="Statut"
                                    >
                                        <ng-template let-data pTemplate="item">
                                            <div class="country-item">
                                                <div>
                                                    {{ data }}
                                                </div>
                                            </div>
                                        </ng-template>
                                    </p-dropdown>
                                </div>
                            </div>
                            <div [style]="{ width: '13rem' }">
                                <label class="block"><b>Date début</b></label>
                                <p-calendar
                                    [(ngModel)]="filterDateStart"
                                    [showIcon]="true"
                                    (ngModelChange)="changeDateStart($event)"
                                    dateFormat="dd-mm-yy"
                                ></p-calendar>
                            </div>
                            <div [style]="{ width: '13rem' }">
                                <label class="block"><b>Date fin </b></label>
                                <p-calendar
                                    [(ngModel)]="filterDateEnd"
                                    [showIcon]="true"
                                    (ngModelChange)="changeDateEnd($event)"
                                    dateFormat="dd-mm-yy"
                                ></p-calendar>
                            </div>
                            <div style="width: 4rem">
                                <p-button
                                    styleClass="p-button-success filter-button"
                                    (click)="onFilter()"
                                    icon="pi pi-filter"
                                    [disabled]="isFilter()"
                                ></p-button>
                            </div>
                        </div>
                        <hr />
                        <div class="table_actions_wrapper">
                            <button
                                pButton
                                pRipple
                                label="Nouvel Achat"
                                (click)="onInitForm()"
                                icon="pi pi-plus"
                                class="p-button-success"
                            ></button>
                            <button
                                pButton
                                pRipple
                                label="Rafraîchir"
                                icon="pi pi-refresh"
                                (click)="OnRefresh()"
                                class="p-button-secondary"
                            ></button>
                            <button
                                pButton
                                pRipple
                                label="Exporter"
                                icon="pi pi-download"
                                class="p-button-helf"
                            ></button>
                        </div>
                        <div class="table_content_wrapper">
                            <div class="table_header">
                                <app-table-header
                                    [count]="listCommandes"
                                    [legende]="'Achats'"
                                ></app-table-header>
                            </div>
                            <table [ngClass]="['native_table table']">
                                <thead>
                                    <th class="text-center">#</th>
                                    <th class="text-center">Date création</th>
                                    <th class="text-center">Transaction</th>
                                    <th class="text-center">Reference</th>
                                    <th class="text-center"># SIM A</th>
                                    <th class="text-center"># SIM B</th>
                                    <th class="text-center">Volume (Go)</th>
                                    <th class="text-center">Initiateur</th>
                                    <th class="text-center">Statut</th>
                                    <th class="text-center">Actions</th>
                                </thead>
                                <tbody>
                                    <tr
                                        *ngFor="
                                            let data of listCommandes
                                                | paginate
                                                    : {
                                                          itemsPerPage:
                                                              recordsPerPage,
                                                          currentPage: p,
                                                          totalPages: totalPage,
                                                          totalItems:
                                                              totalRecords
                                                      };
                                            let i = index
                                        "
                                    >
                                        <td>{{ this.offset + i }}</td>
                                        <td>{{ data?.created_at }}</td>
                                        <td
                                            (click)="copyData(data.transaction)"
                                            style="cursor: pointer"
                                        >
                                            {{ data?.transaction }}
                                        </td>
                                        <td
                                            (click)="
                                                copyData(data.numero_commande)
                                            "
                                            style="cursor: pointer"
                                        >
                                            {{ data?.numero_commande }}
                                        </td>
                                        <td>
                                            {{
                                                pipeValue(data?.nb_sim_a || '0')
                                            }}
                                        </td>
                                        <td>
                                            {{
                                                pipeValue(data?.nb_sim_b || '0')
                                            }}
                                        </td>
                                        <td>
                                            {{
                                                pipeValue(data?.nb_vol_p || '0')
                                            }}
                                        </td>
                                        <td>
                                            {{ data.initiateur?.nom }}
                                            {{ data.initiateur?.prenoms }}
                                        </td>
                                        <td class="text-center">
                                            <span
                                                [ngStyle]="{
                                                    'font-size': '16px'
                                                }"
                                                class="badge"
                                                [class.badge-dark]="
                                                    data?.statut === stateSoumis
                                                "
                                                [class.badge-info]="
                                                    data?.statut === stateTraite
                                                "
                                                [class.badge-success]="
                                                    data?.statut ===
                                                    stateCloture
                                                "
                                            >
                                                {{ data.statut }}
                                            </span>
                                        </td>
                                        <td class="td-actions">
                                            <button
                                                pButton
                                                icon="pi pi-eye"
                                                pTooltip="Voir"
                                                tooltipPosition="top"
                                                (click)="OnShowTraitement(data)"
                                                class="p-button-dark"
                                            ></button>
                                            <button
                                                pButton
                                                icon="pi pi-book"
                                                pTooltip="Journal"
                                                tooltipPosition="top"
                                                (click)="showJournal(data)"
                                                class="p-button-primary"
                                            ></button>
                                            <button
                                                pButton
                                                icon="pi pi-history"
                                                pTooltip="Historique"
                                                tooltipPosition="top"
                                                (click)="onShowForm(data)"
                                                class="p-button-warning"
                                            ></button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div [ngClass]="['pagination-controls']">
                                <pagination-controls
                                    (pageChange)="onPageChange($event)"
                                    previousLabel=""
                                    nextLabel=""
                                >
                                </pagination-controls>
                            </div>
                        </div>
                    </div>
                    <app-commande-form
                        [currentObject]="currentObject"
                        *ngIf="formsView"
                        (formsView)="pushStatutView($event)"
                        (listCommandes)="pushListDatas($event)"
                    ></app-commande-form>
                </div>
            </div>
        </div>
    </div>
</div>
